module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "output"
  }, [_c('h2', [_vm._v("Configuration string")]), _vm._v(" "), _c('div', {
    staticClass: "string"
  }, [_c('div', {
    staticClass: "overflow-cheat"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.match),
      expression: "match"
    }]
  }, [_vm._v("m" + _vm._s(_vm.match))]), _vm._v(" "), _vm._l((_vm.teams), function(team, index) {
    return [(index == 0) ? _c('span', [_vm._v("t" + _vm._s(team))]) : _c('span', [_vm._v(" t" + _vm._s(team))])]
  }), _vm._v(" "), _vm._l((_vm.players), function(player, index) {
    return [(index == 0) ? _c('span', [_vm._v("p" + _vm._s(player))]) : _c('span', [_vm._v(" p" + _vm._s(player))])]
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [(_vm.copied) ? _c('div', {
    key: 1,
    staticClass: "copy-success"
  }, [_vm._v("Copied to clipboard")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "copy",
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("Copy to clipboard")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fdc1e26","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Meta.vue
// module id = 29
// module chunks = 0